import type { LegendSection } from './types';
import type { SymbologyConfig } from './symbology';

type TableLayer = {
	legend?: { symbology?: SymbologyConfig; partOf?: string; hideSymbology?: boolean };
};
type TableModule = { label: string; layers: Record<string, TableLayer> };

export function sectionsFromModuleTable(table: Record<string, TableModule>): LegendSection[] {
	return Object.entries(table).map(([moduleId, m]) => ({
		label: m.label,
		layers: Object.entries(m.layers).map(([layerId, l]) => ({
			moduleId,
			layerId,
			label: layerId,
			symbology: l.legend?.symbology,
			partOf: l.legend?.partOf,
			hideSymbology: l.legend?.hideSymbology
		}))
	}));
}
